import React from 'react';
import Image from "../../../../elements/Image";
import Button from "../../../../form/Button";
import AboutImage from "../../../../../assets/image/bitcoin-about.png";

const HomeAbout = () => {
  return (
    <div className="relative">
      <div className="w-full max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto">
        <div className="flex items-center gap-10 justify-between relative">
          <div className="max-w-[670px]">
            <div className="overflow-hidden w-full">
              <Image src={AboutImage} alt={""} classes={"object-cover"} />
            </div>
          </div>
          <div className="max-w-[760px]">
            <span className="font-Poppins font-semibold text-xl text-primary uppercase">ABOUT US</span>
            <h2 className="text-white font-Poppins font-semibold text-5xl mt-4 leading-[60px]">Real-Time Insights, Long-Term Impact</h2>
            <div className="text-white text-xl mt-9 mb-7 leading-[36px]">
              <p>At the heart of what we do is a commitment to clarity and progress. We help individuals and businesses navigate today’s challenges by tracking short-term changes while keeping a clear vision of long-term goals. Our platform is built to deliver real-time insights, reliable tools, and future-focused solutions that empower growth, innovation, and smarter decision-making—every step of the way.</p>
            </div>
            <Button
              buttonLabel={"Buy Crypto"}
              buttonClasses={"!px-3 md:!px-7 !rounded-lg"}
              buttonLabelClasses={"!text-xs md:!text-[18px] whitespace-nowrap uppercase font-semibold text-white font-Inter"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAbout;